import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=b4557f7a&scoped=true&"
import script from "./RobotList.vue?vue&type=script&lang=js&"
export * from "./RobotList.vue?vue&type=script&lang=js&"
import style0 from "./RobotList.vue?vue&type=style&index=0&id=b4557f7a&lang=less&scoped=true&"
import style1 from "./RobotList.vue?vue&type=style&index=1&id=b4557f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4557f7a",
  null
  
)

export default component.exports